import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {
  setLoading,
  setError,
  setBookings,
  setActiveNurses,
  setCampaigns,
  removeBooking,
  setUserInfo,
  setShifts,
  setCampaignInfo,
  setTimeSlotStatus,
  removeAssignedJobs,
  setCampaignLoading,
  setUpdatedOrder,
  setAddress,
  setProcessing, setNewBooking, setLoader, setSalesOrderStatus, updateSalesOrderStatus,
  setLoaderByType,
  setErrorByType, setUserBookedShift,
  setUserBookedShiftError
} from '../../slices/nurseCampaignSlice'

import {
  getCampaign,
  getActiveNurses,
  getBookings,
  cancelBookings,
  getShifts,
  getBookedShifts,
  generateSalesOrder,
  getUserInfo,
  requestGetAllShifts,
  requestCampaingInfo,
  requestSetTimeSlotStatus,
  requestAssignCampaignToNurse,
  requestUpdateOrder,
  requestNewAddress, requestBookCampaign, requestConfirmSalesOrder, requestUpdateSalesOrder, getUserBookedShift, requestAssignCamapignToNurses, requestShiftAppointments,
} from '../requests/nurseCampaignService'

export function* handleCampaignsGet() {
  try {
    yield put(setLoading())
    const response = yield call(() => getCampaign())
    yield put(setCampaigns(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  }
}

export function* handleActiveNursesGet() {
  try {
    yield put(setLoaderByType({type:"NurseList",loader:true}))
    const response = yield call(() => getActiveNurses())
    yield put(setActiveNurses(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setErrorByType({type:"NurseList",error: errorMsg}))
  }finally{
    yield put(setLoaderByType({type:"NurseList",loader:false}))
  }
}

export function* handleBookingsGet(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => getBookings(action.payload))
    yield put(setBookings(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  }
}

export function* handleBookingCancel(action) {
  try {
    const { payload, appointmentId, campaignId} = action.payload
    yield put(setProcessing(true))
    yield call(() => cancelBookings(payload,appointmentId, campaignId))
    yield put(removeBooking(appointmentId))
    toast.success("Booking Canceled")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
    toast.error("Unable to cancel booking") }
  finally {
    yield put(setProcessing(false))
  }
}

export function* handleGetShifts(action) {
  try {
    yield put(setLoaderByType({type:"ShiftList",loader:true}))
    const result = yield call(() =>
      Promise.all([getShifts(), getBookedShifts(action.payload)]).then(
        (result) => result,
      ),
    )
    yield put(setShifts(result))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setErrorByType({type:"ShiftList",error: errorMsg}))
  }finally{
    yield put(setLoaderByType({type:"ShiftList",loader:false}))
  }
}

export function* handleGenerateSaleOrder(action) {
  try {
    yield put(setLoader(true));
    const response = yield call(() => generateSalesOrder(action.payload))
    yield put(setSalesOrderStatus({
      id: action.payload,
      data: response.data
    }))
    toast.success("Sales order generated")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
    toast.error("Failed to generate sales order")
  }finally {
    yield put(setLoader(false));
  }
}

export function* handleUserInfoGet(action) {
  try {
    yield put(setProcessing(true))
    const response = yield call(() => getUserInfo(action.payload))
    yield put(setUserInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleCampaignBookings(action) {
  try {
    const {campaign_id} = action.payload;
    yield put(setProcessing(true))
    const response = yield call(() => requestBookCampaign(campaign_id, action.payload))
    yield put(setNewBooking(response.data))
    toast.success("Campaign Booked Successfully")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg);
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleCampaignInfoGet(action) {
  try {
    yield put(setLoaderByType({type:"CampaignInfo",loader:true}))
    const response = yield call(() => requestCampaingInfo(action.payload))
    yield put(setCampaignInfo(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setErrorByType({type:"CampaignInfo", error: errorMsg}))
  } finally {
    yield put(setLoaderByType({type:"CampaignInfo",loader:false}))
  }
}

export function* handleChangeTimeSlotStatus(action){
  try {
    yield put(setProcessing(true))
    const response = yield call(() => requestSetTimeSlotStatus(action.payload))
    yield put(setTimeSlotStatus(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleAssignCampaingToNurse(action){
  try {
    yield put(setProcessing(true))
    const response = yield call(() => requestAssignCamapignToNurses(action.payload))
    yield put(removeAssignedJobs({
      ...action.payload,
      jobs : response.data
    }))
    toast.success("Job assigned to Nurse")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleUpdateOrder(action){
  try {
    if(Object.entries(action.payload.order).length <= 1){
      throw new Error("No values were updated")
    }
    yield put(setProcessing(true))
    const response = yield call(() => requestUpdateOrder(action.payload))
    yield put(setUpdatedOrder(response.data))
    toast.success("Order Updated")
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleAddAddress(action){
  try {
    const {userId, address} = action.payload;
    yield put(setLoader(true))
    const response = yield call(() => requestNewAddress(userId, address))
    yield put(setAddress(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError({ error: errorMsg }))
  } finally {
    yield put(setLoader(false))
  }
}

export function* handleUpdateSalesOrder(action){
  try{
    const {index, campaignAppointmentId} = action.payload;
    yield put(setLoader(true))
    const response = yield call(() => requestUpdateSalesOrder(campaignAppointmentId))
    yield put(updateSalesOrderStatus({
      index,
      data:response.data
    }))
    toast.success("Update Sales Order Request Sent")
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  }finally{
    yield put(setLoader(false))
  }
}

export function* handleConfirmSalesOrder(action){
  try{
    const {index, campaignAppointmentId} = action.payload;
    yield put(setLoader(true))
    const response = yield call(() => requestConfirmSalesOrder(campaignAppointmentId))
    yield put(updateSalesOrderStatus({
      index,
      data: response.data
    }))
    toast.success("Sales Order Confirmed")
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  }finally{
    yield put(setLoader(false))
  }
}

export function* handleGetUserBookedShift(action){
  try{
    const {campaignId, patientId} = action.payload;
    yield put(setLoader(true))
    const response = yield call(() => getUserBookedShift(campaignId, patientId))
    yield put(setUserBookedShift(response.data))
  }catch(e){
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
    yield put(setUserBookedShiftError({ error: errorMsg }))
  }finally{
    yield put(setLoader(false))
  }
}

